import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatisticComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  ICampaignEntryReportResult,
  ICampaignRunEstimates,
} from '@principle-theorem/principle-core/interfaces';
import { CampaignRunEstimatesComponent } from '../campaign-run-estimates/campaign-run-estimates.component';

export interface ICampaignEnrolment {
  entries: ICampaignEntryReportResult[];
  skippedEntries: number;
  campaignEntriesInPreview: number;
  estimates: ICampaignRunEstimates;
}

@Component({
  selector: 'pr-campaign-run-enrolment-estimates',
  templateUrl: './campaign-run-enrolment-estimates.component.html',
  styleUrl: './campaign-run-enrolment-estimates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-4' },
  imports: [NgCommonModule, StatisticComponent, CampaignRunEstimatesComponent],
})
export class CampaignRunEnrolmentEstimatesComponent {
  enrolment = input.required<ICampaignEnrolment>();
}
